import React, { useEffect, useState } from "react";
import { withAuthenticationRequired } from "../context/AuthContext";
import Loading from "../components/Loading";
import {
  MenuItem,
  Select,
  TextField,
  Button,
  FormControlLabel,
  Switch
} from "@mui/material";
import { IoDice } from "react-icons/io5";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { showErrorMessage } from "../redux/appSlice";
import { useDispatch } from "react-redux";
import ImageUploadField from "../components/ImageUploadField";
import { useRequestHandler } from "../utils/useRequestHandler";
import { useStateWithCallback } from "../utils/useStateWithCallback";
import { useTypeThenRun } from "../utils/useTypeThenRun";
import { useNavigate } from "react-router-dom";
import Servicios from "../services";
import { GiPodium } from "react-icons/gi";
import { useEffectSinEjecucionInicial } from "../utils/useEffectSinEjecucionInicial";

export const Pencas = () => {
  const [pencas, setPencas] = useState([]);
  const [agregando, setAgregando] = useState(false);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [descripcionPremio, setDescripcionPremio] = useState("");
  const [concursos, setConcursos] = useStateWithCallback([]);
  const [concursoId, setConcursoId] = useState(0);
  const [concursoActualId, setConcursoActualId] = useState(0);
  const [esPrivada, setEsPrivada] = useState(true);
  const [clave, setClave] = useState("");
  const [esPatrocinada, setEsPatrocinada] = useState(false);
  const [tienePremio, setTienePremio] = useState(false);
  const [editando, setEditando] = useState(false);
  const [idEditando, setIdEditando] = useState(0);

  const [imagen, setImagen] = useState();
  const [imagenPremio, setimagenPremio] = useState();
  const [imgPreviewSrc, setImgPreviewSrc] = useState("");
  const [imgPremioPreviewSrc, setimgPremioPreviewSrc] = useState("");
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const navigate = useNavigate();
  const sendRequest = useRequestHandler();
  const dispatch = useDispatch();

  const refrescarGrilla = () => {
    sendRequest(Servicios.ObtenerPencas, [textoBusqueda], data => {
      setPencas(data?.data);
    });
  };

  const limpiarForm = () => {
    setNombre("");
    setImagen(null);
    setimagenPremio(null);
    setImgPreviewSrc("");
    setimgPremioPreviewSrc("");
    setDescripcion("");
    setConcursoId(concursoActualId);
    setEsPrivada(true);
    setClave("");
    setEsPatrocinada(false);
    setDescripcionPremio("");
    setTienePremio(false);
  };

  useEffect(() => {
    refrescarGrilla();
  }, []);

  useEffectSinEjecucionInicial(() => {
    if (esPatrocinada) {
      setEsPrivada(false);
      setTienePremio(true);
    }
  }, [esPatrocinada]);

  useEffectSinEjecucionInicial(() => {
    if (!tienePremio) {
      setEsPatrocinada(false);
    }
  }, [tienePremio]);

  useTypeThenRun(textoBusqueda, refrescarGrilla);

  const eliminarPenca = id => {
    sendRequest(Servicios.EliminarPenca, [id], refrescarGrilla);
  };

  useEffect(() => {
    if (agregando) {
      sendRequest(Servicios.ObtenerConcursos, [], data => {
        setConcursos(data?.data, () => {
          sendRequest(Servicios.ObtenerConcursoActual, [], data2 => {
            if (!editando) setConcursoId(data2.data.id);
            setConcursoActualId(data2.data.id);
          });
        });
      });
    }
  }, [agregando]);

  const columns = [
    { field: "id", headerName: "ID", flex: 10 },
    { field: "nombre", headerName: "Nombre", flex: 80 },
    {
      field: "actionResultados",
      headerName: "",
      sortable: false,
      flex: 10,
      align: "right",
      renderCell: params => {
        return (
          <>
            <GiPodium
              size={30}
              className="action-icon"
              onClick={() =>
                navigate(`/resultados-penca/${params?.row?.id}`)
              }
              title={"Resultados"}
            />
          </>
        );
      }
    },
    {
      field: "actionPredict",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        const onClick = e => {
          navigate(`/pronosticar/${params?.row?.id}`);
        };

        return (
          <IoDice
            size={28}
            className="action-icon"
            title="Pronosticar"
            onClick={onClick}
          />
        );
      }
    },
    {
      field: "actionEdit",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        const onClick = e => {
          setAgregando(true);
          setEditando(true);
          setIdEditando(params.row.id);

          sendRequest(Servicios.ObtenerPencaPorId, [params.row.id], data => {
            setNombre(data.data.nombre);
            setDescripcion(data.data.descripcion);
            setConcursoId(data.data.concursoId);
            setEsPrivada(data.data.esPrivada);
            setClave(data.data.clave);
            setEsPatrocinada(!!data.data.clave);
            setImgPreviewSrc(data.data.imagenPath);
            setimgPremioPreviewSrc(data.data.premioImagenPath);
            setTienePremio(data.data.tienePremio);
            setDescripcionPremio(data.data.premioDescripcion);
          });
        };

        return (
          <EditIcon
            size={28}
            className="action-icon"
            title="Editar"
            onClick={onClick}
          />
        );
      }
    },
    {
      field: "actionDelete",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        const onClick = e => {
          if (window.confirm("¿Confirmás eliminar la penca?")) {
            eliminarPenca(params?.row?.id);
          }
        };

        return (
          <DeleteIcon
            size={28}
            className="action-icon"
            title="Eliminar"
            onClick={onClick}
          />
        );
      }
    }
  ];

  const handleGuardar = () => {
    if (editando) {
      sendRequest(
        Servicios.ModificarPenca,
        [
          {
            id: idEditando,
            nombre: nombre,
            descripcion: descripcion,
            esPrivada: esPrivada,
            clave: esPatrocinada ? clave : "",
            concursoId: concursoId,
            tienePremio: tienePremio,
            premioDescripcion: descripcionPremio
          },
          imagen,
          imagenPremio
        ],
        data => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
        }
      );
    } else {
      sendRequest(
        Servicios.CrearPenca,
        [
          {
            nombre: nombre,
            descripcion: descripcion,
            esPrivada: esPrivada,
            clave: esPatrocinada ? clave : "",
            concursoId: concursoId,
            tienePremio: tienePremio,
            premioDescripcion: descripcionPremio
          },
          imagen,
          imagenPremio
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
        }
      );
    }
  };

  return (
    <>
      <>
        {!agregando ? (
          <div className="card-modern">
            <div className="flex items-center justify-between gap-4 page-header">
              <h4 className="page-title">Listado de pencas</h4>
              <div className="flex-1">
                <TextField
                  className="w-80"
                  size="small"
                  label="Buscar"
                  value={textoBusqueda}
                  onChange={e => setTextoBusqueda(e.target.value)}
                />
              </div>
              <div>
                <Button
                  variant={"contained"}
                  onClick={() => {
                    setAgregando(true);
                  }}
                >
                  Agregar
                </Button>
              </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="grid-wrapper w-full">
              {pencas?.length > 0 ? (
                <DataGrid
                  rows={pencas}
                  columns={columns}
                  paginationModel={{ page: 0, pageSize: 50 }}
                  checkboxSelection={false}
                />
              ) : (
                <h5>No se encontraron resultados</h5>
              )}
            </div>
          </div>
        ) : (
          <div className="card-modern">
            <div className="flex items-center justify-between gap-4 page-header">
              <h4 className="page-title">{editando ? "Modificar penca" : "Nueva penca"}</h4>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1 flex flex-col gap-3">
                <div className="mb-3">
                  <TextField
                    className="w-full"
                    size="small"
                    label="Nombre"
                    value={nombre}
                    onChange={e => setNombre(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    className="w-full"
                    size="small"
                    label="Descripción"
                    value={descripcion}
                    onChange={e => setDescripcion(e.target.value)}
                    multiline
                    rows={6}
                  />
                </div>
                <div className="mb-3">
                  <Select
                    size="small"
                    className="w-full"
                    placeholder="Concurso"
                    value={concursoId}
                    onChange={e => setConcursoId(e.target.value)}
                  >
                    {concursos?.map(c => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="mb-3">
                  <FormControlLabel
                    control={
                      <Switch
                        disabled={esPatrocinada}
                        checked={esPrivada}
                        onChange={e => setEsPrivada(value => !value)}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                    label="Es privada"
                    labelPlacement="start"
                  />
                </div>
                <div className="mb-3">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={esPatrocinada}
                        onChange={e => setEsPatrocinada(value => !value)}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                    label="Es patrocinada"
                    labelPlacement="start"
                  />
                </div>
                <div className="mb-3">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={tienePremio}
                        onChange={e => setTienePremio(value => !value)}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                    label="Tiene premio"
                    labelPlacement="start"
                  />
                </div>
                <div className="mb-3">
                  {esPatrocinada && (
                    <TextField
                      className="w-full"
                      size="small"
                      label="Clave"
                      value={clave}
                      onChange={e => setClave(e.target.value)}
                    />
                  )}
                </div>
                {tienePremio && (
                  <div className="mb-3">
                    <TextField
                      className="w-full"
                      size="small"
                      label="Descripción del premio"
                      value={descripcionPremio}
                      onChange={e => setDescripcionPremio(e.target.value)}
                      multiline
                      rows={6}
                    />
                  </div>
                )}
              </div>
              <div className="flex-1 flex flex-col gap-4">
                <ImageUploadField
                  value={imagen}
                  previewSrc={imgPreviewSrc}
                  onChange={(file, previewDataUrl) => {
                    setImagen(file);
                    setImgPreviewSrc(previewDataUrl);
                  }}
                  onError={message => dispatch(showErrorMessage(message))}
                  label="Cargar imagen"
                />
                {tienePremio && (
                  <ImageUploadField
                    value={imagenPremio}
                    previewSrc={imgPremioPreviewSrc}
                    onChange={(file, previewDataUrl) => {
                      setimagenPremio(file);
                      setimgPremioPreviewSrc(previewDataUrl);
                    }}
                    onError={message => dispatch(showErrorMessage(message))}
                    label="Imagen Premio"
                    inputId="upload-photo-premio"
                  />
                )}
              </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="flex justify-between items-center w-full">
              <div className="text-start">
                <Button
                  variant={"outlined"}
                  onClick={() => {
                    setEditando(false);
                    setAgregando(false);
                    limpiarForm();
                  }}
                >
                  Cancelar
                </Button>
              </div>
              <div className="text-end">
                <Button variant={"contained"} onClick={handleGuardar}>
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default withAuthenticationRequired(Pencas, {
  onRedirecting: () => <Loading />
});
